<template>
  <view-linkable :content-element="contentElement" :entry="entry">
    <blank-fallback :is-blank="isBlank(value)">
      {{value}}
    </blank-fallback>
  </view-linkable>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewTableMixin from "../mixins/listViewTableMixin";

  export default Vue.extend({
    mixins: [
      listViewTableMixin,
    ],
    computed: {
      value() {
        return this.entry.view_data?.content_element_data?.[this.contentElement.client_id];
      }
    },
  });
</script>